import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import Prochainement from "../../Assets/Projects/Prochainement.webp";
import Portfolio from "../../Assets/Projects/Portfolio.webp";
import Wikijs from "../../Assets/Projects/Wikijs.webp";
import ODM from "../../Assets/Projects/ODM.webp";
import Herning2025 from "../../Assets/Projects/Herning2025.svg";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Mes <strong className="purple">projets </strong> récents
        </h1>
        <p style={{ color: "white" }}>
          Voici quelques projets.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Portfolio}
              isBlog={false}
              title="Portfolio"
              description="Ce projet est un site web destiné à présenter mon parcours, mes compétences et mes réalisations dans le domaine des systèmes et réseaux."
              demoLink="https://www.vcreton.fr/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Wikijs}
              isBlog={false}
              title="Wiki"
              description="Ce projet est une plateforme qui héberge l’ensemble des procédures (en cours de rédaction)."
              demoLink="https://docs.hubinfra.fr/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ODM}
              isBlog={false}
              title="Worldskills 2027"
              description="Organisation de la compétition nationales."
              demoLink="https://www.worldskills-france.org"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Herning2025}
              isBlog={false}
              title="Herning2025"
              description="Rédaction du sujet Windows et participation à la rédaction du script de correction."
              ghLink="https://github.com/WS-EE/ES2025-Skill39-Scoring-ModuleB"
              demoLink="https://euroskills2025.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Prochainement}
              isBlog={false}
              title="Prochainement"
              description="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque id augue quam. Suspendisse pharetra auctor blandit. Pellentesque maximus interdum maximus. Proin finibus mi sed finibus pellentesque. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut non iaculis dolor. In elit ex, gravida in erat eget, rhoncus interdum elit. Aliquam lacinia tortor sit amet urna lacinia tincidunt. Suspendisse volutpat varius fringilla. Proin sed ultrices dolor, a maximus nunc. Sed et auctor lacus, sed aliquam ligula. Morbi tincidunt mollis tortor ut porttitor."
              //ghLink="https://github.com/soumyajit4419/AI_For_Social_Good"
              // demoLink="https://www.youtube.com/watch?v=dQw4w9WgXcQ&ab_channel=RickAstley" <--------Please include a demo link here
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Prochainement}
              isBlog={false}
              title="Prochainement"
              description="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque id augue quam. Suspendisse pharetra auctor blandit. Pellentesque maximus interdum maximus. Proin finibus mi sed finibus pellentesque. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut non iaculis dolor. In elit ex, gravida in erat eget, rhoncus interdum elit. Aliquam lacinia tortor sit amet urna lacinia tincidunt. Suspendisse volutpat varius fringilla. Proin sed ultrices dolor, a maximus nunc. Sed et auctor lacus, sed aliquam ligula. Morbi tincidunt mollis tortor ut porttitor."
              //ghLink="https://github.com/soumyajit4419/Face_And_Emotion_Detection"
              // demoLink="https://blogs.soumya-jit.tech/"      <--------Please include a demo link here 
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
